import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_ctx.breakpoint === 'xs' || _ctx.breakpoint === 'sm')
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "info",
            variant: "tonal",
            class: "mx-auto mb-4",
            "max-width": "400",
            density: "compact"
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode(" Use a larger screen for a better experience. This app is best viewed on a tablet or desktop. ")
            ])),
            _: 1,
            __: [7]
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card, {
        class: _normalizeClass(['mx-auto', 'pa-2', 'card', { 'mt-8': _ctx.breakpoint === 'xs' || _ctx.breakpoint === 'sm', 'mt-16': _ctx.breakpoint !== 'xs' && _ctx.breakpoint !== 'sm' }]),
        "max-width": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" New Account ")
                ])),
                _: 1,
                __: [8]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_form, {
            onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                "model-value": _ctx.email,
                "onUpdate:modelValue": _ctx.onEmailInput,
                name: "email",
                label: "Email",
                type: "text",
                placeholder: "Email",
                variant: "outlined",
                required: "",
                rules: _ctx.emailRules,
                autofocus: "",
                class: "mx-2"
              }, null, 8, ["model-value", "onUpdate:modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                name: "username",
                label: "Username",
                type: "text",
                placeholder: "Username",
                variant: "outlined",
                required: "",
                rules: _ctx.usernameRules,
                class: "mx-2"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.first,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.first) = $event)),
                name: "first",
                label: "First Name",
                type: "text",
                placeholder: "First Name",
                variant: "outlined",
                required: "",
                rules: _ctx.firstRules,
                class: "mx-2"
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.last,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.last) = $event)),
                name: "last",
                label: "Last Name",
                type: "text",
                placeholder: "Last Name",
                variant: "outlined",
                class: "mx-2"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                name: "password",
                label: "Password",
                type: "password",
                placeholder: "Password",
                variant: "outlined",
                required: "",
                rules: _ctx.passwordRules,
                onKeydown: _withKeys(_ctx.register, ["enter"]),
                class: "mx-2"
              }, null, 8, ["modelValue", "rules", "onKeydown"]),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.confirmPassword,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                name: "confirmPassword",
                label: "Confirm Password",
                type: "password",
                placeholder: "Confirm Password",
                variant: "outlined",
                required: "",
                rules: _ctx.confirmPasswordRules,
                onKeydown: _withKeys(_ctx.register, ["enter"]),
                class: "mx-2"
              }, null, 8, ["modelValue", "rules", "onKeydown"]),
              (_ctx.signupCodesEnabled)
                ? (_openBlock(), _createBlock(_component_v_text_field, {
                    key: 0,
                    modelValue: _ctx.code,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.code) = $event)),
                    name: "signupCode",
                    label: "Signup Code",
                    type: "text",
                    placeholder: "Signup Code",
                    variant: "outlined",
                    rules: _ctx.signupCodeRules,
                    required: "",
                    onKeydown: _withKeys(_ctx.register, ["enter"]),
                    class: "mx-2"
                  }, null, 8, ["modelValue", "rules", "onKeydown"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.terms,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.terms) = $event)),
                label: "",
                required: "",
                onKeydown: _withKeys(_ctx.register, ["enter"])
              }, {
                label: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" I agree to the "),
                  _createElementVNode("a", {
                    href: "https://missionsquad.ai/privacy",
                    target: "_blank"
                  }, "terms and conditions", -1),
                  _createTextVNode(". ")
                ])),
                _: 1
              }, 8, ["modelValue", "onKeydown"])
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _withModifiers(_ctx.register, ["stop","prevent"]),
                text: "Register",
                disabled: _ctx.registerDisabled(),
                variant: "outlined"
              }, null, 8, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}